export default {
    xsmall: 0,
    small: 576,
    medium: 768,
    large: 1024,
    xlarge: 1180,
    xxlarge: 1440
}